

var mailingList = function(){

	/**
	 * [initDatePicker description]
	 * @return {[type]} [description]
	 */
	var initDatePicker = function()
	{
		$('.datepicker').pickadate({
			formatSubmit: 'dd-mm-yyyy'
		});
	};

	/**
	 * [initSweetAleart description]
	 * @return {[type]} [description]
	 */
	var initSweetAleart = function()
	{

		var selectors = [
			'.mailing-list.list .trash.icon'
		];

		if( $(selectors.join(', ')).length ) {

			$(selectors.join(', ')).parent().click( function(e){
				var button = $(this);
				e.preventDefault();
				swal({
			        title: "Are you sure?",
			        text: "This action cannot be reversed",
			        type: "warning",
			        showCancelButton: true,
			        confirmButtonClass: 'btn-danger',
			        confirmButtonText: 'Yes, delete it!',
			        cancelButtonText: "No, cancel please!",
			        closeOnConfirm: false,
			        closeOnCancel: false
		        }, function( isConfirm ) {
			        if ( isConfirm ) {
			            window.location = button.attr('href');
			        } else {
			            swal.close();
			        }
			    });
			});

		}
	};

	/**
	 * [init description]
	 * @return {[type]} [description]
	 */
	this.init = function()
	{
		initDatePicker();
		initSweetAleart();
	};

};


jQuery(document).ready( function($){

	if( $('.mailing-list').length ) {

		var app = new mailingList();
		app.init();

	}

});